// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"63f84492","821":"ff928f07"}[chunkId] + ".chunk.js";
};